export enum CellIndicatorScore {
    Negative = 0,
    Positive = 1,
    Unkown = 2
}
